export default "__VITE_ASSET__81fwySDw__"